module.exports = __webpack_public_path__ + "static/media/cent-title.70984785.jpg";